<template>
  <LoadingProgressBar />
  <router-view />
  <div class="h-[70px]" v-if="this.$route.path !== '/login'"></div>
  <div v-if="$route.name !== 'Login'">
    <BottomNavigation />
    <!-- <CustomerBottomSheet v-model:visible="this.$customer.value" /> -->
    <GpsToast />
  </div>
</template>

<script>
import BottomNavigation from "./components/BottomNavigation.vue";
import LoadingProgressBar from "@/components/General/Loading-ProgressBar";
import GpsToast from "./components/GpsToast.vue";
//import CustomerBottomSheet from "./components/CustomerBottomSheet.vue";
export default {
  name: "App",
  components: { BottomNavigation, LoadingProgressBar, GpsToast },
};
</script>

<style>
@font-face {
  font-family: "iransans";
  src: url("assets/font/iran_sans.ttf");
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

*::-webkit-scrollbar {
  display: none;
}

html,
body {
  font-family: "iransans" !important;
  direction: rtl;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: #e6ecea;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.router-link-active {
  @apply text-blue-900;
}
</style>
